import KdiagramCalculationResultFdmData from "./data";

export default function mapFdmDataFromJson(json) {
  return new KdiagramCalculationResultFdmData(
    json["fdm"]["LOG_Speed"],
    json["fdm"]["ME_Power"],
    json["fdm"]["ME_RPM"],
    new Date(json["fdm_min_date"]),
    new Date(json["fdm_max_date"]),
    json["fdm_length"],
    json["FDMDataClength"],
    json["fdm"]["ME_DAILY_FOC_tpd"]
  );
}
